import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: '#efb530',
        textColor: '#000',
        // alternateTextColor: '#000'
    },
});

export default muiTheme;


// WEBPACK FOOTER //
// ./src/theme.js